/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQOptionUpdateId } from './mCQOptionUpdateId';
import type { MCQOptionUpdateFeedback } from './mCQOptionUpdateFeedback';
import type { MCQOptionUpdateImageUrl } from './mCQOptionUpdateImageUrl';
import type { MCQOptionUpdateImageAlt } from './mCQOptionUpdateImageAlt';

/**
 * Request to update an MCQ option (ID optional, generated if missing).
 */
export interface MCQOptionUpdate {
  id?: MCQOptionUpdateId;
  text: string;
  isCorrect: boolean;
  feedback?: MCQOptionUpdateFeedback;
  imageUrl?: MCQOptionUpdateImageUrl;
  imageAlt?: MCQOptionUpdateImageAlt;
}
